import { Socket, io } from 'socket.io-client';

import { getAuthClient, getUser, getToken } from '@verantos-dev/core-auth';

let socket: Socket | undefined;

export const initSocket = async (path: string, namespace?: string): Promise<undefined> => {
  if (socket?.connected) {
    return;
  }

  const client = await getAuthClient();
  const auth0User = await client.getUser();
  const url = new URL(import.meta.env.VITE_BASE_SOCKET_URL);
  url.pathname = namespace ?? url.pathname;

  if (auth0User && !socket) {
    const user = getUser(auth0User);
    socket = io(url.toString(), {
      path,
      auth: async (cb) => {
        cb({ token: await getToken() });
      },
      transports: ['websocket'],
      reconnection: true,
      query: {
        userId: user.auth0Id,
        user: `${user.firstName} ${user.lastName}`,
      },
    });
  }
};

export const getSocketV2ResearchAssistant = async (
  namespace?: string
): Promise<Socket | undefined> => {
  await initSocket('/v1/message-gateway', namespace);
  return socket;
};

export const cleanupSocketV2ResearchAssistant = () => {
  socket?.disconnect();
  socket = undefined;
};

export const emitSocketV2ResearchAssistantEvent = (event: string, data: unknown) => {
  if (socket) {
    socket.emit(event, data);
  }
};
